import { buildUrl, handleResponse } from "./auth";

const jsonHeaders = { "Content-Type": "application/json" };

export const getAdminEmailTemplates = () =>
  fetch(buildUrl("/api/admin/notifications/email-templates"), {
    credentials: "include",
  }).then(handleResponse);

export const getAdminEmailTemplate = (type) =>
  fetch(buildUrl(`/api/admin/notifications/email-templates/${type}`), {
    credentials: "include",
  }).then(handleResponse);

export const updateAdminEmailTemplate = (type, payload) =>
  fetch(buildUrl(`/api/admin/notifications/email-templates/${type}`), {
    method: "PUT",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const previewAdminEmailTemplate = (payload) =>
  fetch(buildUrl("/api/admin/notifications/email-templates/preview"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const testSendAdminEmailTemplate = (payload) =>
  fetch(buildUrl("/api/admin/notifications/email-templates/test-send"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const sendAdminEmailTemplate = (payload) =>
  fetch(buildUrl("/api/admin/notifications/email-templates/send"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const previewAdminCustomEmail = (payload) =>
  fetch(buildUrl("/api/admin/notifications/email-templates/custom-preview"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const customSendAdminEmail = (payload) =>
  fetch(buildUrl("/api/admin/notifications/email-templates/custom-send"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

const adminEmailTemplatesApi = {
  getAdminEmailTemplates,
  getAdminEmailTemplate,
  updateAdminEmailTemplate,
  previewAdminEmailTemplate,
  testSendAdminEmailTemplate,
  sendAdminEmailTemplate,
  previewAdminCustomEmail,
  customSendAdminEmail,
};

export default adminEmailTemplatesApi;
